export default {"src":"/_next/static/media/appStoreWhite.d6b87b91.svg","height":48,"width":144};